import { apiFetch } from "../utils/apiFetch"

export type InboxMessage = {
  id: string
  title: string
  body: string
  link: string | null
  // What the message is about. Messages from before these fields existed have none.
  kind: "received" | "filed" | "power-of-attorney" | null
  applicationType: "trademark" | "design" | "patent" | null
  reference: string | null
  read: boolean
  createdAt: string
}

export function getMessages() {
  return apiFetch("/api/messages") as Promise<{ messages: InboxMessage[] }>
}

export function getUnreadCount() {
  return apiFetch("/api/messages/unread-count") as Promise<{ unread: number }>
}

export function markMessageRead(id: string) {
  return apiFetch(`/api/messages/${encodeURIComponent(id)}/read`, { method: "POST" })
}

export function markAllMessagesRead() {
  return apiFetch("/api/messages/read-all", { method: "POST" })
}

// Removes the message, the application it is about stays as it is
export function deleteMessage(id: string) {
  return apiFetch(`/api/messages/${encodeURIComponent(id)}`, { method: "DELETE" })
}
